import Vue from 'vue'
import {UuidGenerator} from '../UuidGenerator'
export class Factory {
  id(prefix) {
    return `${prefix}_${(new UuidGenerator).build()}`
  }

  createVariation(variation) {
    return this.markup(variation)
  }

  markup(variationProperties) {
    let markup = this.object()
    Object.keys(variationProperties).forEach(property => Vue.set(markup, property, variationProperties[property]))
    Vue.set(markup, 'properties', this.properties())
    return markup
  }
}